import { render, staticRenderFns } from "./sevenAverageProductionSales.vue?vue&type=template&id=18ad1736&scoped=true&"
import script from "./sevenAverageProductionSales.vue?vue&type=script&lang=js&"
export * from "./sevenAverageProductionSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad1736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ad1736')) {
      api.createRecord('18ad1736', component.options)
    } else {
      api.reload('18ad1736', component.options)
    }
    module.hot.accept("./sevenAverageProductionSales.vue?vue&type=template&id=18ad1736&scoped=true&", function () {
      api.rerender('18ad1736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/sevenAverageProductionSales.vue"
export default component.exports